import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { BadgeGlyphComponent } from './components/badge-glyph.component';
import { BadgeCollectionComponent } from './components/badge-collection.component';
import { BadgeLeaderboardsComponent } from './components/badge-leaderboards.component';
import { MiniBadgeComponent } from './components/mini-badge.component';
import { MiniBadgeCollectionComponent } from './components/mini-badge-collection.component';
import { StatsSkeletonComponent } from './components/stats-skeleton.component';

const components = [BadgeGlyphComponent, BadgeCollectionComponent, BadgeLeaderboardsComponent,
    MiniBadgeComponent, MiniBadgeCollectionComponent, StatsSkeletonComponent];

/** Owns the badges' directive scope for static and CAP-created component views. */
@NgModule({ imports: [CommonModule, FormsModule, RouterModule, NgbPopoverModule],
    declarations: components, exports: components })
export class GamificationModule {}
